<template>
	<div>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/iot/Packet' }">分组管理 ( {{$route.query.name}} )</el-breadcrumb-item>
						<el-breadcrumb-item>设备信息</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<div class="s-title" v-if="$route.query.type!=1">
					<b>传感器信息</b>
				</div>
				<div class="s-title" v-else>
					<b>烟雾报警器信息</b>
				</div>
			</el-col>
			<el-col :span="12">
				<div style="text-align: right;">
					<span>刷新时间：</span>
					<el-input :size="$store.state.width<$store.state.minwidth?'small':''" @blur="editsx()" class="sxsj" v-model.number="sxsj"
					 placeholder="请输入内容"></el-input>
					<span>s</span>
					<!-- <h3>检测时间：{{detectionTime}}</h3> -->
				</div>
			</el-col>
		</el-row>
		<div v-if="$route.query.type!=1">
			<el-row v-if="Sensor.length>0">
				<el-col :span="24">
					<div v-for="(item, key) in Sensor" :key="key" class="card-w">
						<el-card class="top1" shadow="hover" :body-style="{ padding: '0px' }">
							<div class="top2">
								<div class="top3">
									<span class="name1">{{item.name}}</span>
									<span v-if="item.state=='0'" class="lixian" type="text"><i class="el-icon-success"></i> 禁用</span>
									<span v-else-if="item.state=='1'" class="zaixian" type="text"><i class="el-icon-success"></i> 在线</span>
									<span v-else-if="item.state=='2'" class="lixian" type="text"><i class="el-icon-question"></i> 未使用</span>
									<span v-else-if="item.state=='3'" class="lixian" type="text"><i class="el-icon-error"></i> 离线</span>
									<span v-else class="lixian" type="text"><i class="el-icon-warning"></i> 异常</span>
								</div>
							</div>
							<div>
								<el-row>
									<el-col :span="9">
										<div class="tupian">
											<img :src="config.apiurl + item.image" class="image1">
										</div>
									</el-col>
									<el-col :span="15">
										<div class="bzd" align="center">
											<span class="yrbzd">{{item.value}}</span>
											<br />
											采集时间:
											<br />
											<span class="yrtime">{{item.updatetime}}</span>
										</div>
									</el-col>
								</el-row>
								<div>
									<hr color=#EBEEF5 SIZE=1 />
									<el-row>
										<el-col :span="8">
											<el-button class="shishi" type="text" @click="OpenCurve(item)">实时曲线</el-button>
										</el-col>
										<el-col :span="8">
											<el-button class="tongb" type="text" @click="OpenCompare(item)">数据同比</el-button>
										</el-col>
										<el-col :span="8">
											<el-button class="lishi" type="text" @click="OpenHistory(item)">历史数据</el-button>
										</el-col>
									</el-row>
								</div>
							</div>
						</el-card>
					</div>
				</el-col>
			</el-row>
			<el-row v-else>
				<el-col :span="24">
					<div class="none">
						<span>暂无数据 ！</span>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<div>
						<hr color=#45B2EB SIZE=1 />
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<div class="s-title">
						<b>控制器信息</b>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-row v-if="Equipment.length>0">
			<el-col :span="24">
				<div class="card-w">
					<el-card v-for="(item, key) in Equipment" :key="key" shadow="hover" :body-style="{ padding: '0px' }" class="card1">
						<div class="card2">
							<div class="card3">
								<span class="card4">{{item.name}}</span>
								<el-switch v-model="Equipment[key].value" active-color="green" inactive-color="#e6e6e6" style="float: right;"
								 @change="OpenClose($event,item)"></el-switch>
								<span v-if="item.state2=='0'" class="lixian" type="text"><i class="el-icon-success"></i> 禁用</span>
								<span v-else-if="item.state2=='1'" class="zaixian" type="text"><i class="el-icon-success"></i> 在线</span>
								<span v-else-if="item.state2=='2'" class="lixian" type="text"><i class="el-icon-question"></i> 未使用</span>
								<span v-else-if="item.state2=='3'" class="lixian" type="text"><i class="el-icon-error"></i> 离线</span>
								<span v-else class="lixian" type="text"><i class="el-icon-warning"></i> 异常</span>
							</div>
						</div>
						<div :style="item.terminalType==1?'cursor: pointer;':''" @click="item.terminalType==1?$router.push({path: '/iot/history',query: {id: item.id,type: 1,zd: Terminalid}}):''">
							<div v-if="!(item.fdetector == 'a'||item.fdetector == 'ry'||item.fdetector == 'sw'||item.fdetector == 'solenoid'||item.fdetector == 'butt_bamper')"
							 style="height: 22px;"></div>
							<el-row>
								<el-col :span="9">
									<div class="hsbzd">
										<img v-if="item.value" :src="config.apiurl + item.image2" class="image2">
										<img v-else :src="config.apiurl + item.image1" class="image3">
									</div>
								</el-col>
								<el-col v-if="item.terminalType==1" :span="15">
									<div align="center">
										<el-row style="margin-top: 25px;">
											<el-col :span="10">电量:</el-col>
											<el-col :span="14">{{item.devicesData.battery}} %</el-col>
										</el-row>
										<el-row style="margin-top: 15px;">
											<el-col :span="10">状态:</el-col>
											<el-col :span="14"><span :style="'color: '+ state(item.devicesData.smoke_stat).color +';'">{{state(item.devicesData.smoke_stat).label}}</span></el-col>
										</el-row>
									</div>
								</el-col>
								<el-col v-if="item.terminalType==1" :span="24" style="border-top: 1px solid #1991FA; line-height: 25px;">
									<el-row>
										<el-col :span="24">{{ Totime(item.devicesData.updateTime) }}</el-col>
									</el-row>
								</el-col>
								<el-col v-else :span="15">
									<div class="zi1" align="center">
										<br />
										<br />
										<span class="zi2">{{item.state}}</span>
									</div>
								</el-col>
							</el-row>
							<div v-if="!(item.fdetector == 'a'||item.fdetector == 'ry'||item.fdetector == 'sw'||item.fdetector == 'solenoid'||item.fdetector == 'butt_bamper')"
							 style="height: 22px;"></div>
							<div v-if="item.fdetector == 'a'||item.fdetector == 'ry'||item.fdetector == 'sw'||item.fdetector == 'solenoid'||item.fdetector == 'butt_bamper'">
								<hr color=#EBEEF5 SIZE=1 />
								<el-row>
									<el-col :span="24" style="text-align: center;">
										<el-button type="text" class="log-button" @click="$router.push({path: '/iot/Aerationoperate',query: { id: item.id, Packet: Terminalid }})">操作日志</el-button>
									</el-col>
								</el-row>
							</div>
						</div>
					</el-card>
				</div>
			</el-col>
		</el-row>
		<el-row v-else>
			<el-col :span="24">
				<div class="none">
					<span>暂无数据 ！</span>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				myload: true,
				Terminalid: null,
				detectionTime: "",
				Sensor: [],
				Equipment: [],
				sdetector: {
					water: "wdevice",
					land: "ldevice",
					sky: "skdevice",
					qt: "qt"
				},
				timer: null,
				time: null,
				sxsj: 10
			}
		},
		watch: {
			$route: {
				handler: function(val, oldVal) {
					this.myload = true;
					this.load();
				}
			}
		},
		beforeDestroy: function() {
			this.close();
		},
		mounted: function() {
			this.load();
		},
		methods: {
			close() {
				clearInterval(this.timer);
			},
			OpenCurve(item) {
				this.$router.push({
					path: '/iot/current',
					query: {
						id: item.id,
						Packet: this.Terminalid,
						name: this.$route.query.name
					}
				});
			},
			OpenCompare(item) {
				this.$router.push({
					path: '/iot/compare',
					query: {
						id: item.id,
						Packet: this.Terminalid,
						name: this.$route.query.name
					}
				});
			},
			OpenHistory(item) {
				this.$router.push({
					path: '/iot/history',
					query: {
						id: item.id,
						Packet: this.Terminalid,
						name: this.$route.query.name
					}
				});
			},
			state(value) {
				let state = [{
						label: "正常",
						color: "green"
					},
					{
						label: "有烟",
						color: "red"
					},
					{
						label: "电量过低",
						color: "#BA0001"
					}
				]
				return state[Number(value)];
			},
			OpenClose($event, item) {
				if (this.time == null) {
					this.time = new Date().getTime() - 3001;
				}
				if (new Date().getTime() - this.time < 3000) {
					this.$message({
						message: "3s内不可连续操作！",
						type: 'error',
						center: true,
					});
					item.value = !$event;
					return;
				}
				this.time = new Date().getTime();
				if (item.state2 != 1 || item.state == "正在打开" || item.state == "正在关闭" || item.state == "故障") {
					this.$message({
						message: "当前状态设备不可控制！",
						type: 'error',
						center: true,
					});
					item.value = !$event;
					return;
				}
				this.axios.post(this.config['apiurl'] + '/api/devices/update', {
						token: this.getCookie(this.config["token"]),
						id: item.id,
						devicetype: "final",
						isSwitch: $event ? 1 : 0
					})
					.then((response) => {
						if (response.data.code == 1) {
							this.$message({
								message: $event ? "开启成功" : "成功关闭",
								type: 'success',
								center: true,
							});
						} else if (response.data.code == 0) {
							this.$message({
								message: $event ? "开启失败" : "关闭失败",
								type: 'error',
								center: true,
							});
						}
						this.load();
					})
					.catch((response) => {
						console.log(response);
						this.loginV(response.toString());
					});
			},
			back() {
				this.$router.push({
					name: 'ZdInformation',
					params: {
						id: ''
					}
				});
			},
			editsx() {
				if (this.sxsj < 2) {
					this.$message({
						message: "刷新时间不能小于2s！请重新修改！",
						type: 'error',
						center: true,
					});
					this.sxsj = 10;
				}
				if (!Number(this.sxsj)) {
					this.$message({
						message: "请输入数字！",
						type: 'error',
						center: true,
					});
					this.sxsj = 10;
				}
				clearInterval(this.timer);
				this.timer = setInterval(this.load, this.sxsj * 1000); //刷新
			},
			load() {
				if (this.timer == null) {
					this.timer = setInterval(this.load, this.sxsj * 1000); //刷新
					this.$store.commit('mainload', true);
				}
				this.Terminalid = this.$route.query.id;
				if (this.$route.query.id == null) {
					this.Sensor = [];
					this.Equipment = [];
					return;
				}
				this.api.Packet.read({
						id: this.Terminalid
					})
					.then((response) => {
						if (response.data.code == 1) {
							this.Sensor = [];
							this.Equipment = [];
							for (var i = 0; i < response.data.data.terminalDevicesInfo.devicesInfo.length; i++) {
								if (response.data.data.terminalDevicesInfo.devicesInfo[i].devicetype == "sensor") {
									var value = response.data.data.terminalDevicesInfo.devicesInfo[i];
									var unit = value.unit != 0 ? "(" + value.unit + ")" : "";
									this.Sensor.push({
										id: value.id,
										name: value.alias + unit,
										state: value.state,
										image: value.image,
										value: value.devicesDataInfo == null ? "无数据" : value.devicesDataInfo.content,
										updatetime: value.devicesDataInfo == null ? "当前未采集到数据" : this.Totime(value.devicesDataInfo.updatetime)
									});
								}
								if (response.data.data.terminalDevicesInfo.devicesInfo[i].devicetype == "final") {
									var value = response.data.data.terminalDevicesInfo.devicesInfo[i];
									this.Equipment.push({
										id: value.id,
										name: value.alias,
										state: value.isSwitch == 1 ? "开启" : "关闭",
										image1: value.image,
										image2: value.image,
										value: value.isSwitch == 1,
										state2: value.state,
										terminalType: value.terminalType,
										devicesData: value.devicesData,
										fdetector: value.fdetector
									});
								}
							}
							this.$store.commit('mainload', false);
						}
					});
			}
		}
	}
</script>

<style scoped>
	.zi2 {
		font-size: 2.5rem;
	}

	.zi1 {
		margin-bottom: 1.25rem;
	}

	.yrbzd {
		font-size: 2.5rem;
	}

	.yrtime {
		font-size: 16px;
	}

	.hsbzd {
		margin: auto;
	}

	.image3 {
		width: 7rem;
		height: 7rem;
		border-radius: 7rem;
		box-shadow: darkgrey 0px 0px 8px 1px inset;
	}

	.image2 {
		width: 7rem;
		height: 7rem;
		border-radius: 7rem;
		box-shadow: darkgrey 0px 0px 8px 1px inset;
	}

	.bzd {
		margin-bottom: 1.25rem;
		font-size: 16px;
	}

	.card4 {
		color: #555;
		font-size: 16px;
	}

	.card3 {
		padding-top: 3px;
	}

	.card2 {
		background-color: #9faec5;
		height: 2rem;
		border-bottom: 0.0625rem solid #EBEEF5;
	}

	.image1 {
		width: 7rem;
		height: 7rem;
		border-radius: 7rem;
		box-shadow: darkgrey 0px 0px 8px 1px inset;
	}

	.tupian {
		margin: auto;
	}

	.lixian {
		float: right;
		color: gray;
		margin-right: 0.9375rem;
		font-size: 14px;
		padding-top: 3px;
	}

	.zaixian {
		float: right;
		color: green;
		margin-right: 0.9375rem;
		font-size: 14px;
		padding-top: 3px;
	}

	.name1 {
		color: #555;
		font-size: 16px;
	}

	.top3 {
		padding-top: 3px;
	}

	.top2 {
		background-color: #9faec5;
		height: 2rem;
		border-bottom: 0.0625rem solid #EBEEF5;
	}

	.top1 {
		width: 305px;
		text-align: center;
		margin-top: 10px;
		float: left;
		margin-right: 10px;
	}

	.lishi {
		padding: 0;
		padding-bottom: 8px;
	}

	.tongb {
		padding: 0;
		padding-bottom: 8px;
	}

	.shishi {
		padding: 0;
		padding-bottom: 8px;
	}

	.card1 {
		width: 305px;
		height: 195px;
		text-align: center;
		margin-top: 10px;
		float: left;
		margin-right: 10px;
	}

	.s-title {
		font-size: 18px;
		line-height: 40px;
	}

	.log-button {
		padding: 0;
		padding-bottom: 10px;
	}

	.none {
		margin-top: 80px;
		margin-bottom: 80px;
		text-align: center;
		font-size: 80px;
		font-family: "STCaiyun";
		color: #1991FA;
	}

	.sxsj {
		width: 50px;
	}

	.bread {
		height: 14px;
		padding: 8px 0;
	}

	@media screen and (min-width: 0px) and (max-width: 700px) {
		.bread {
			padding-left: 5px;
		}

		.s-title {
			margin-left: 5px;
		}

		.top1,
		.card1 {
			float: none;
			width: 100%;
			margin: 0;
		}

		.card-w {
			padding: 5px;
		}
	}
</style>
